import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './compound-title.module.css';

interface Props {
    title: string;
}

export function CompoundTitle(props: Props) {
    return (
        <Stack spacing={24} alignItems='center'>
            <Stack isHorizontal={true} spacing={8} alignItems='center' justifyContent='center'>
                <div className={styles.icon}>
                    {/* @ts-expect-error */}
                    <AiSparkleNewIcon size={20} color={colors.aiPurpleMd} />
                </div>
                <div className={styles.subtitle}>
                    <Body isBold={true} color='ai-purple'>
                        AI-powered Sales CRM and Marketing automation
                    </Body>
                </div>
            </Stack>
            <div className={styles.title}>{props.title}</div>
        </Stack>
    );
}
